import styled from 'styled-components';
import { AuthorFlyout, Text } from '@morressier/ts';
import { StyledUnderlineLink } from 'containers/SingleSession/styles';
import Link from 'next/link';

const AuthorsContainer = styled.div`
  display: inline;

  div:not(:last-child) span:after {
    content: ',';
    margin-right: 4px;
    display: inline-block;
    vertical-align: top;
    line-height: 1.5rem;
  }
`;

type AuthorsProps = {
  eventId: string;
  items: MorressierUser[] | Chair[];
  embargoed?: boolean;
  loading?: boolean;
};
const Authors = (props: AuthorsProps) => {
  const { items, eventId } = props;

  if (props.loading) {
    return (
      <Text size="body1_new" color="grey" style={{ lineHeight: 1.25, marginBottom: '0.5rem' }}>
        Loading authors...
      </Text>
    );
  }

  if (items?.length > 0) {
    return (
      <AuthorsContainer>
        {items
          .filter(a => !!a.full_name)
          .map(author =>
            author.is_activated ? (
              <AuthorFlyout
                key={author._id}
                author={author}
                trigger={
                  <Link
                    href={{
                      pathname: props.embargoed
                        ? '/profile/[userId]'
                        : '/event/[eventId]/people/[userId]',
                      query: { eventId, userId: author._id },
                    }}
                    passHref
                  >
                    <StyledUnderlineLink as="a" target="_self" style={{ lineHeight: '1.5rem' }}>
                      {author.full_name}
                    </StyledUnderlineLink>
                  </Link>
                }
                placement="right"
              />
            ) : (
              <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
                <span>
                  <Text key={author._id} style={{ whiteSpace: 'pre', display: 'inline' }}>
                    {author.full_name}
                  </Text>
                </span>
              </div>
            ),
          )}
      </AuthorsContainer>
    );
  }

  return (
    <Text size="body1_new" color="grey" style={{ lineHeight: 1.25, marginBottom: '0.5rem' }}>
      No author information is available for this submission.
    </Text>
  );
};

Authors.defaultProps = {
  embargoed: false,
} as const;

export default Authors;
